import React from 'react';

import { useMFAttachedDocumentsContext } from '~/microfrontend/hooks/useMFModuleNameContext';
import { AttachedDocumentsWidget } from '~/widgets/AttachedDocumentsWidget';
import { AttachedImagesWidget } from '~/widgets/AttachedImagesWidget';
import { FileModeEnum } from '~modules/fileTypes/types/FileModeEnum';

export const WidgetRenderer: React.FC = () => {
  const { mode } = useMFAttachedDocumentsContext();

  const WidgetsMap = {
    [FileModeEnum.IMAGES_EXCLUDED]: <AttachedDocumentsWidget />,
    [FileModeEnum.IMAGES_ONLY]: <AttachedImagesWidget />,
    [FileModeEnum.ALL]: <></>,
  };

  // Renders

  return WidgetsMap[mode];
};
